import { openSubscriptionPolicies, renderSubscriptionPolicy } from './subscription-policy'
import { widgetState } from '../../store/customizations/index'
import { templateFactory } from './widgets/template-factory'
import { getSellingPlanGroups } from '../../store/selling-plans/getters'
import { getProduct } from '../../store/product/getters'
import { isTilesLayout } from '../../store/customizations/getters'
import { replacePriceElementTiles } from './widgets/tiles-label'
import { replacePriceElement } from './widgets/price-label'
import { buildElement } from '../../utils/element'

export const renderProduct = (mainElement: HTMLElement): void => {
  if (getSellingPlanGroups().length === 0) {
    return
  }
  const product = getProduct()
  const template = widgetState.customizations.selectionType.split('-')[0]
  const selectedTemplate = templateFactory(template, product).render()
  const element = buildElement('div', 'yotpo-plans-and-policy-wrapper', {})
  mainElement.appendChild(element)
  element.appendChild(selectedTemplate)
  renderSubscriptionPolicy(element)
  if (product.requiresSellingPlan || (widgetState.customizations.autoPickOptionIndex > 0 && !widgetState.customizations.oneTimeAtLast)) {
    if (widgetState.customizations.subscriptionPolicy.shouldShow) {
      openSubscriptionPolicies()
    }
  }
}

export const replacePrices = () => {
  if (isTilesLayout()) {
    replacePriceElementTiles()
  } else {
    replacePriceElement()
  }
}
